export const ADD_ACCOUNT_APP_LICENSE= "ADD_ACCOUNT_APP_LICENSE";
export const GET_ACCOUNT_APP_LICENSES="GET_ACCOUNT_APP_LICENSES";
export const ACCOUNT_APP_LICENSES="ACCOUNT_APP_LICENSES";
export const DELETE_ACCOUNT_APP_LICENSE='DELETE_ACCOUNT_APP_LICENSE';
export const UPDATE_ACCOUNT_APP_LICENSE = 'UPDATE_ACCOUNT_APP_LICENSE';
export const ACCOUNT_APP_LICENSE_MESSAGE='ACCOUNT_APP_LICENSE_MESSAGE';
export const SET_ADD_EDIT = 'SET_ADD_EDIT';
export const SHOW_LOADING='SHOW_LOADING';
export const HIDE_LOADING="HIDE_LOADING";
export const ADD_ACCOUNT_APP_LICENSE_PURCHASE= "ADD_ACCOUNT_APP_LICENSE_PURCHASE";
export const GET_ACCOUNT_APP_LICENSE_PURCHASES="GET_ACCOUNT_APP_LICENSE_PURCHASES";
export const ACCOUNT_APP_LICENSE_PURCHASES="ACCOUNT_APP_LICENSE_PURCHASES";
export const DELETE_ACCOUNT_APP_LICENSE_PURCHASE='DELETE_ACCOUNT_APP_LICENSE_PURCHASE';
export const UPDATE_ACCOUNT_APP_LICENSE_PURCHASE = 'UPDATE_ACCOUNT_APP_LICENSE_PURCHASE';
export const SAVE_ACCOUNT_APP_LICENSE_DATA="SAVE_ACCOUNT_APP_LICENSE_DATA";
export const ACCOUNT_APP_LICENSES_DATA="ACCOUNT_APP_LICENSES_DATA";
export const GET_ACCOUNT_APP_LICENSE_DATA="GET_ACCOUNT_APP_LICENSE_DATA";
export const SAVED_ACCOUNT_APP_LICENSES_DATA="SAVED_ACCOUNT_APP_LICENSES_DATA";
